import Multiselect from 'multiselect-react-dropdown';
import React, {useState,useEffect,useRef,useLayoutEffect,useMemo,useCallback} from 'react'
import './ModalProtocolEditData.css'
import {  BsGripVertical, BsLightbulbFill, BsLightbulbOff, BsTrashFill} from 'react-icons/bs'

const ModalProtocolDataEdit = ({closeModal, onSubmit, protocolEdit, protocolDataEdit, isNewProtocol, allPodLights, allSoundFrequencies, isLoading = false, isReadOnly = false}) => {
    const isReadOnlyMode = !!isReadOnly;
    const protocolInfo = protocolEdit;
    const [protocolData, setProtocolData] = useState([]);
    const [protocolSequences, setProtocolSequences] = useState(0);
    const [dragSourceIndex, setDragSourceIndex] = useState(null);
    const [dropInsertIndex, setDropInsertIndex] = useState(null);
    const [deletingSequenceId, setDeletingSequenceId] = useState(null);
    const allLights = allPodLights || [];
    const allAudioFrequencies = allSoundFrequencies || [];

    const multiselectRefs = useRef({});
    const cardRefs = useRef({});
    const scrollContainerRef = useRef(null);
    const dragPointerYRef = useRef(null);
    const autoScrollFrameRef = useRef(null);
    const pendingFlipPositionsRef = useRef(null);
    const droppedSequenceIdRef = useRef(null);
    const nextSequenceUiId = useRef(1);
    const deleteTimerRef = useRef(null);
    const pointerDraggingRef = useRef(false);
    const pointerCaptureTargetRef = useRef(null);
    const pointerCaptureIdRef = useRef(null);
    const pointerDragStartYRef = useRef(null);
    const dragSourceIndexRef = useRef(null);
    const dropInsertIndexRef = useRef(null);

    const setDragSourceIndexSynced = (value) => {
        dragSourceIndexRef.current = value;
        setDragSourceIndex(value);
    }

    const setDropInsertIndexSynced = (value) => {
        dropInsertIndexRef.current = value;
        setDropInsertIndex(value);
    }

    const resetDragInteractionState = () => {
        setDragSourceIndexSynced(null);
        setDropInsertIndexSynced(null);
        dragPointerYRef.current = null;
        pointerDragStartYRef.current = null;
        stopAutoScroll();
    }

    const stopAutoScroll = () => {
        if (autoScrollFrameRef.current !== null) {
            window.cancelAnimationFrame(autoScrollFrameRef.current);
            autoScrollFrameRef.current = null;
        }
    }

    const runAutoScroll = () => {
        const container = scrollContainerRef.current;
        if (!container || dragSourceIndexRef.current === null || isReadOnlyMode) {
            stopAutoScroll();
            return;
        }

        const pointerY = dragPointerYRef.current;
        if (pointerY !== null) {
            const rect = container.getBoundingClientRect();
            const edgeThreshold = 72;
            let scrollDelta = 0;

            if (pointerY < rect.top + edgeThreshold) {
                scrollDelta = -Math.min(18, Math.ceil((rect.top + edgeThreshold - pointerY) / 4));
            } else if (pointerY > rect.bottom - edgeThreshold) {
                scrollDelta = Math.min(18, Math.ceil((pointerY - (rect.bottom - edgeThreshold)) / 4));
            }

            if (scrollDelta !== 0) {
                container.scrollTop += scrollDelta;
            }
        }

        autoScrollFrameRef.current = window.requestAnimationFrame(runAutoScroll);
    }

    const startAutoScroll = () => {
        if (autoScrollFrameRef.current === null) {
            autoScrollFrameRef.current = window.requestAnimationFrame(runAutoScroll);
        }
    }

    useEffect(() => {
        if (isLoading) {
            return;
        }

        if (isNewProtocol) {
            const newSequenceData = [
                {
                    sequence: '1',
                    duration: 0,
                    audio_frequency: 'Random Chakra',
                    light_groups: [
                        {
                            light: '',
                            frequency: '',
                            duty_cycle: '50',
                        },
                    ],
                    __uiId: 'seq-1',
                },
            ];
            setProtocolData(newSequenceData);
            setProtocolSequences(1);
            nextSequenceUiId.current = 2;
            return;
        }

        if (!protocolDataEdit || !Array.isArray(protocolDataEdit.protocol_data)) {
            return;
        }

        const normalizedProtocolData = protocolDataEdit.protocol_data.map((sequence, idx) => ({
            ...sequence,
            audio_frequency: sequence.audio_frequency || 'Same as Lights',
            __uiId: sequence.__uiId || `seq-${idx + 1}`,
        }));

        setProtocolData(normalizedProtocolData);
        setProtocolSequences(normalizedProtocolData.length);
        nextSequenceUiId.current = normalizedProtocolData.length + 1;
    }, [isLoading, isNewProtocol, protocolDataEdit]);

    const captureCardPositions = () => {
        const positions = {};
        protocolData.forEach((sequence) => {
            const cardElement = cardRefs.current[sequence.__uiId];
            if (cardElement) {
                positions[sequence.__uiId] = cardElement.getBoundingClientRect().top;
            }
        });
        return positions;
    }

    useLayoutEffect(() => {
        const firstPositions = pendingFlipPositionsRef.current;
        if (!firstPositions) {
            return;
        }

        protocolData.forEach((sequence) => {
            const cardElement = cardRefs.current[sequence.__uiId];
            if (!cardElement) {
                return;
            }

            const firstTop = firstPositions[sequence.__uiId];
            const lastTop = cardElement.getBoundingClientRect().top;
            if (firstTop === undefined) {
                return;
            }

            const deltaY = firstTop - lastTop;
            if (deltaY === 0) {
                return;
            }

            cardElement.style.transition = 'none';
            cardElement.style.transform = `translateY(${deltaY}px)`;

            requestAnimationFrame(() => {
                cardElement.style.transition = 'transform 240ms ease';
                cardElement.style.transform = 'translateY(0)';
            });
        });

        const droppedId = droppedSequenceIdRef.current;
        if (droppedId && cardRefs.current[droppedId]) {
            const droppedCard = cardRefs.current[droppedId];
            droppedCard.classList.remove('sequence-drop-complete');
            void droppedCard.offsetWidth;
            droppedCard.classList.add('sequence-drop-complete');
            window.setTimeout(() => {
                droppedCard.classList.remove('sequence-drop-complete');
            }, 320);
        }

        pendingFlipPositionsRef.current = null;
        droppedSequenceIdRef.current = null;
    }, [protocolData]);

    useEffect(() => {

        // console.log(protocolInfo)
        // console.log(protocolData)
        // console.log(protocolSequences)
        // console.log(allLights)
        // console.log(currentSequenceLights)

    }, []);

    useEffect(() => {
        return () => {
            if (deleteTimerRef.current) {
                window.clearTimeout(deleteTimerRef.current);
            }
            pointerDraggingRef.current = false;

            // Force-reset drag state on unmount to avoid stale drag locks.
            setDragSourceIndexSynced(null);
            setDropInsertIndexSynced(null);
            dragPointerYRef.current = null;
            if (autoScrollFrameRef.current !== null) {
                window.cancelAnimationFrame(autoScrollFrameRef.current);
                autoScrollFrameRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        document.body.classList.add('protocol-data-modal-open');

        return () => {
            document.body.classList.remove('protocol-data-modal-open');
        };
    }, []);

    useEffect(() => {
        const resetDragState = () => {
            pointerDraggingRef.current = false;
            setDragSourceIndexSynced(null);
            setDropInsertIndexSynced(null);
            dragPointerYRef.current = null;
            if (autoScrollFrameRef.current !== null) {
                window.cancelAnimationFrame(autoScrollFrameRef.current);
                autoScrollFrameRef.current = null;
            }
        };

        window.addEventListener('dragend', resetDragState);
        window.addEventListener('drop', resetDragState);

        return () => {
            window.removeEventListener('dragend', resetDragState);
            window.removeEventListener('drop', resetDragState);
        };
    }, []);

    const apiPatchProtocolData = async (protocolId, patchProtocolData) => {
        //console.log(JSON.stringify(patchProtocolInfo))
        try{
            const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/protocols/protocol/' + protocolId,
                {
                    method: 'PATCH',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(patchProtocolData),
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            await response.json();
        } catch (error) {
            console.error(error);
        }
    }

    function trimEdges(str) {
        if (str.startsWith(' ')) {
            str = str.slice(1);
        }
        if (str.endsWith(' ')) {
            str = str.slice(0, -1);
        }
        return str;
    }

    const validateForm = async () => {
        var patchProtocolData = []
        protocolData.forEach(sequence => {
            const sequenceCopy = {
                ...sequence,
                duration: parseFloat(sequence.duration) || 0,
                sequence: parseInt(sequence.sequence) || 0,
                light_groups: sequence.light_groups.map(light_group => ({
                    ...light_group,
                    light: trimEdges(light_group.light),
                })),
            };
            delete sequenceCopy.__uiId;
            patchProtocolData.push(sequenceCopy)
        })
        const arrayProtolData = Array.from(patchProtocolData)
        // console.log(patchProtocolData);
        // console.log(arrayProtolData);
        var protocolId = protocolInfo.id;
        await apiPatchProtocolData(protocolId, {'protocol_data':arrayProtolData})
        return true;
    }

    const formatMinutes = (minutesValue) => {
        const totalSeconds = Math.max(0, Math.round((parseFloat(minutesValue) || 0) * 60));
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${String(seconds).padStart(2, '0')}`;
    }

    const getChipPaletteForValue = useCallback((value) => {
        const normalized = String(value || '').trim().toLowerCase();
        const key = normalized.replace(/\s+/g, '');

        if (key === 'green') {
            return {
                backgroundColor: '#22c55e',
                borderColor: '#16a34a',
                textColor: '#ffffff',
            };
        }

        if (key === 'red660') {
            return {
                backgroundColor: '#dc2626',
                borderColor: '#b91c1c',
                textColor: '#ffffff',
            };
        }

        const irPalette = {
            ir810: { backgroundColor: '#f87171', borderColor: '#ef4444', textColor: '#000000' },
            ir850: { backgroundColor: '#fca5a5', borderColor: '#f87171', textColor: '#000000' },
            ir940: { backgroundColor: '#fecaca', borderColor: '#fca5a5', textColor: '#000000' },
            ir1060: { backgroundColor: '#fee2e2', borderColor: '#fecaca', textColor: '#000000' },
        };

        if (irPalette[key]) {
            return irPalette[key];
        }

        return {
            backgroundColor: '#efefef',
            borderColor: '#000000',
            textColor: '#000000',
        };
    }, [])

    const totalProtocolMinutes = useMemo(() => {
        return protocolData.reduce((totalMinutes, sequence) => {
            return totalMinutes + (parseFloat(sequence.duration) || 0);
        }, 0);
    }, [protocolData]);

    const applyChipPaletteStyles = useCallback(() => {
        const chipElements = document.querySelectorAll('.lights-field .multiselect-container .chip');
        chipElements.forEach((chipElement) => {
            const chipLabelElement = chipElement.querySelector('.chip-label');
            const chipLabel = chipLabelElement ? (chipLabelElement.textContent || '') : (chipElement.textContent || '').replace('×', '').trim();
            const palette = getChipPaletteForValue(chipLabel);
            chipElement.style.setProperty('background-color', palette.backgroundColor, 'important');
            chipElement.style.setProperty('border', '1px solid #b7c6da', 'important');
            chipElement.style.setProperty('color', palette.textColor, 'important');
            chipElement.style.setProperty('font-weight', '500', 'important');

            const closeIcons = chipElement.querySelectorAll('.closeIcon, .icon_cancel, i');
            closeIcons.forEach((iconElement) => {
                iconElement.style.setProperty('color', palette.textColor, 'important');
                iconElement.style.setProperty('opacity', '1', 'important');
                iconElement.style.setProperty('font-weight', '600', 'important');
                iconElement.style.setProperty('-webkit-text-fill-color', palette.textColor, 'important');
            });
        });
    }, [getChipPaletteForValue]);

    useEffect(() => {
        applyChipPaletteStyles();

        // Multiselect updates chips asynchronously; observe and restyle on DOM changes.
        const observer = new MutationObserver(() => {
            window.requestAnimationFrame(() => {
                applyChipPaletteStyles();
            });
        });

        const containers = document.querySelectorAll('.lights-field .multiselect-container');
        containers.forEach((container) => {
            observer.observe(container, {
                childList: true,
                subtree: true,
            });
        });

        return () => {
            observer.disconnect();
        };
    }, [protocolData, isLoading, applyChipPaletteStyles]);

    useEffect(() => {
        const handleChipClickRemove = (event) => {
            const chipElement = event.target.closest('.lights-field .multiselect-container .chip');
            if (!chipElement) {
                return;
            }

            if (event.target.closest('.closeIcon, .icon_cancel, .custom-close, i')) {
                return;
            }

            const removeControl = chipElement.querySelector('.closeIcon, .icon_cancel, .custom-close, i');
            if (!removeControl) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            removeControl.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        };

        document.addEventListener('click', handleChipClickRemove);

        return () => {
            document.removeEventListener('click', handleChipClickRemove);
        };
    }, []);

    const sequenceStartMinutes = useMemo(() => {
        let currentStartMinutes = totalProtocolMinutes;
        return protocolData.map((sequence) => {
            const startMinutes = currentStartMinutes;
            currentStartMinutes -= parseFloat(sequence.duration) || 0;
            return Math.max(0, startMinutes);
        });
    }, [protocolData, totalProtocolMinutes]);

    const showProtocolInfo = () => {
        if (isNewProtocol) {
            return (
                <></>
            )
        }
        else {
            return (
                <div className='protocol-title-row'>
                    <span className='protocol-title-name'>{protocolInfo.name}</span>
                    <span className='protocol-title-chip'>ID: {protocolInfo.id}</span>
                    <span className='protocol-title-chip'>Total Time: {formatMinutes(totalProtocolMinutes)}</span>
                </div>
            )
        }
    }

    const onSelectHandler = (seq_idx, lg_idx) => (selectedList, selectedItem) => {
        handleSelect(selectedList, selectedItem, seq_idx, lg_idx);
    }

    const handleSelect = (selectedList,selectedItem, seq_idx, lg_idx) => {
        // console.log(selectedItem);
        // console.log(selectedList);
        // console.log(seq_idx);
        // console.log(lg_idx);
        var selectedLights = protocolData[seq_idx].light_groups[lg_idx].light;
        selectedItem.light_value.split(' ').forEach(light => {
            if (!selectedLights.includes(light)) {
                selectedLights += ' ' + light;
            }
        })
        const newlights = [...protocolData];
        newlights[seq_idx].light_groups[lg_idx].light = selectedLights;
        setProtocolData(newlights);
    }

    const onRemoveHandler = (seq_idx, lg_idx) => (selectedList, selectedItem) => {
        handleRemove(selectedList, selectedItem, seq_idx, lg_idx);
    }

    const handleRemove = (selectedList, removedItem, seq_idx, lg_idx) => {
        // current light string
        let selectedLights = protocolData[seq_idx].light_groups[lg_idx].light;

        // convert to array (split on spaces, filter out empties)
        let lightsArray = selectedLights.split(' ').filter(Boolean);

        // remove any lights that match the removed item
        const lightsToRemove = removedItem.light_value.split(' ');
        lightsArray = lightsArray.filter(light => !lightsToRemove.includes(light));

        // join back into a string
        selectedLights = lightsArray.join(' ');

        // update state
        const newLights = [...protocolData];
        newLights[seq_idx].light_groups[lg_idx].light = selectedLights;
        setProtocolData(newLights);
    };

    // const handleRemove = (selectedList, selectedItem) => {
    //     // (selectedItem.light_value);
    //     // var currentLights = currentSequenceLights[currentSequenceLightIndex].light;
    //     // var newLightsArray = selectedItem.light_value.split(' ')
    //     // newLightsArray.forEach(light => {
    //     //     currentLights = currentLights.replace(light,'');
    //     //     currentLights = currentLights.replace('   ',' ');
    //     //     currentLights = currentLights.replace('  ',' ');
    //     // })
    //     // setCurrentSequenceLights(prevLights => {
    //     //     const newLights = [...prevLights]; // Create a copy of the array
    //     //     newLights[currentSequenceLightIndex].light = currentLights; // Update the element at the specific index
    //     //     return newLights; // Return the new array
    //     // });
    // }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isLoading) {
            return;
        }
        // console.log(protocolInfo)
        var isValidated = await validateForm()
        if (!isValidated) return;

        onSubmit(protocolInfo);
        closeModal();
    }

    const normalizeSequenceOrder = (sequences) => {
        return sequences.map((sequence, idx) => ({
            ...sequence,
            sequence: (idx + 1).toString(),
        }));
    }

    const commitSequenceReorder = (sourceIndex, targetInsertIndex) => {
        if (sourceIndex === null || sourceIndex < 0 || sourceIndex >= protocolData.length) {
            return;
        }

        const firstPositions = captureCardPositions();
        let insertAt = targetInsertIndex ?? sourceIndex;

        const reordered = [...protocolData];
        const [movedSequence] = reordered.splice(sourceIndex, 1);

        if (sourceIndex < insertAt) {
            insertAt -= 1;
        }

        reordered.splice(insertAt, 0, movedSequence);
        const normalized = normalizeSequenceOrder(reordered);
        pendingFlipPositionsRef.current = firstPositions;
        droppedSequenceIdRef.current = movedSequence.__uiId;
        setProtocolData(normalized);
        setProtocolSequences(normalized.length);
    }

    const getInsertIndexFromPointerY = (pointerY) => {
        const sequenceRects = protocolData
            .map((sequence, idx) => ({
                idx,
                rect: cardRefs.current[sequence.__uiId]?.getBoundingClientRect(),
            }))
            .filter((entry) => !!entry.rect);

        if (!sequenceRects.length) {
            return null;
        }

        // Clamp hard at list edges so top/bottom drops remain stable.
        if (pointerY <= sequenceRects[0].rect.top) {
            return 0;
        }

        const lastRect = sequenceRects[sequenceRects.length - 1].rect;
        if (pointerY >= lastRect.bottom) {
            return sequenceRects.length;
        }

        for (let i = 0; i < sequenceRects.length; i += 1) {
            const midpoint = sequenceRects[i].rect.top + (sequenceRects[i].rect.height / 2);
            if (pointerY < midpoint) {
                return i;
            }
        }

        return sequenceRects.length;
    }

    const stopPointerDragListeners = () => {
        window.removeEventListener('pointermove', handlePointerMove);
        window.removeEventListener('pointerup', handlePointerUp);
        window.removeEventListener('pointercancel', handlePointerUp);

        if (pointerCaptureTargetRef.current && pointerCaptureIdRef.current !== null) {
            try {
                pointerCaptureTargetRef.current.releasePointerCapture(pointerCaptureIdRef.current);
            } catch (error) {
                // Ignore if pointer capture is already released.
            }
        }
        pointerCaptureTargetRef.current = null;
        pointerCaptureIdRef.current = null;
    }

    const handlePointerMove = (e) => {
        const currentSourceIndex = dragSourceIndexRef.current;
        if (!pointerDraggingRef.current || currentSourceIndex === null || isReadOnlyMode || deletingSequenceId !== null) {
            return;
        }

        dragPointerYRef.current = e.clientY;
        startAutoScroll();

        const startY = pointerDragStartYRef.current ?? e.clientY;
        const dragDistance = Math.abs(e.clientY - startY);
        if (dragDistance < 6) {
            setDropInsertIndexSynced(null);
            return;
        }

        const insertIndex = getInsertIndexFromPointerY(e.clientY);
        if (insertIndex !== null) {
            if (insertIndex === currentSourceIndex || insertIndex === currentSourceIndex + 1) {
                setDropInsertIndexSynced(null);
            } else {
                setDropInsertIndexSynced(insertIndex);
            }
        }
    }

    const handlePointerUp = (e) => {
        if (!pointerDraggingRef.current) {
            return;
        }

        pointerDraggingRef.current = false;
        stopPointerDragListeners();

        const currentSourceIndex = dragSourceIndexRef.current;
        let currentInsertIndex = dropInsertIndexRef.current;

        const releaseY = typeof e?.clientY === 'number' ? e.clientY : dragPointerYRef.current;
        if (typeof releaseY === 'number') {
            const releaseInsertIndex = getInsertIndexFromPointerY(releaseY);
            if (releaseInsertIndex === currentSourceIndex || releaseInsertIndex === currentSourceIndex + 1) {
                currentInsertIndex = null;
            } else if (releaseInsertIndex !== null) {
                currentInsertIndex = releaseInsertIndex;
            }
        }

        if (currentSourceIndex !== null) {
            commitSequenceReorder(currentSourceIndex, currentInsertIndex);
        }

        resetDragInteractionState();
    }

    const handlePointerDragStartSequence = (idx) => (e) => {
        if (isReadOnlyMode || deletingSequenceId !== null) {
            return;
        }

        // Only begin custom drag on primary pointer button.
        if (typeof e.button === 'number' && e.button !== 0) {
            return;
        }

        e.preventDefault();

        if (typeof e.currentTarget?.setPointerCapture === 'function' && typeof e.pointerId === 'number') {
            try {
                e.currentTarget.setPointerCapture(e.pointerId);
                pointerCaptureTargetRef.current = e.currentTarget;
                pointerCaptureIdRef.current = e.pointerId;
            } catch (error) {
                pointerCaptureTargetRef.current = null;
                pointerCaptureIdRef.current = null;
            }
        }

        pointerDraggingRef.current = true;
        resetDragInteractionState();
        setDragSourceIndexSynced(idx);
        setDropInsertIndexSynced(null);
        dragPointerYRef.current = e.clientY;
        pointerDragStartYRef.current = e.clientY;
        startAutoScroll();

        window.addEventListener('pointermove', handlePointerMove);
        window.addEventListener('pointerup', handlePointerUp);
        window.addEventListener('pointercancel', handlePointerUp);
    }

    const handleDragStartSequence = (idx) => (e) => {
        if (isReadOnlyMode || deletingSequenceId !== null) {
            e.preventDefault();
            return;
        }
        resetDragInteractionState();
        setDragSourceIndexSynced(idx);
        dragPointerYRef.current = e.clientY;
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', `${idx}`);
    }

    const handleDragOverSequence = (idx) => (e) => {
        if (isReadOnlyMode || deletingSequenceId !== null) {
            return;
        }
        e.preventDefault();
        if (dragSourceIndex === null) {
            return;
        }
        startAutoScroll();
        dragPointerYRef.current = e.clientY;
        const rect = e.currentTarget.getBoundingClientRect();
        const insertIndex = e.clientY < rect.top + rect.height / 2 ? idx : idx + 1;
        if (insertIndex === dragSourceIndex || insertIndex === dragSourceIndex + 1) {
            setDropInsertIndexSynced(null);
        } else {
            setDropInsertIndexSynced(insertIndex);
        }
    }

    const handleDragLeaveSequence = () => {}

    const handleDropSequence = (e) => {
        if (isReadOnlyMode || deletingSequenceId !== null) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (dragSourceIndex === null) {
            return;
        }

        commitSequenceReorder(dragSourceIndex, dropInsertIndex);
        resetDragInteractionState();
    }

    const handleDragEndSequence = () => {
        pointerDraggingRef.current = false;
        stopPointerDragListeners();
        resetDragInteractionState();
    }

    const handleSequenceCardsDragOver = (e) => {
        if (isReadOnlyMode || deletingSequenceId !== null || dragSourceIndex === null) {
            return;
        }

        e.preventDefault();
        startAutoScroll();
        dragPointerYRef.current = e.clientY;
    }

    const removeSequenceById = (sequenceUiId, firstPositions = null) => {
        if (firstPositions) {
            pendingFlipPositionsRef.current = firstPositions;
        }
        droppedSequenceIdRef.current = null;

        setProtocolData((prevSequences) => {
            const updatedSequences = [...prevSequences];
            const removeIndex = updatedSequences.findIndex(sequence => sequence.__uiId === sequenceUiId);
            if (removeIndex < 0) {
                return prevSequences;
            }

            updatedSequences.splice(removeIndex, 1);
            const normalized = normalizeSequenceOrder(updatedSequences);
            setProtocolSequences(normalized.length);
            return normalized;
        });
    }

    const handleAddSequence = async () => {
        if (isReadOnlyMode) {
            return;
        }
        var addLightGroup = {
            'light': '',
            'frequency': '',
            'duty_cycle': '50'
        }
        var addSequence = {
            'duration': '3',
            'sequence': (protocolSequences + 1).toString(),
            'light_groups': [addLightGroup],
            '__uiId': `seq-${nextSequenceUiId.current++}`,
        }
        const newSequence = [...protocolData];
        newSequence.push(addSequence);
        setProtocolData(newSequence);
        setProtocolSequences(protocolSequences + 1);
        // console.log(newSequence);
        // console.log(protocolData);
    }

    const handleRemoveSequenceByIndex = (index) => () => {
        if (isReadOnlyMode || deletingSequenceId !== null) {
            return;
        }

        const sequence = protocolData[index];
        if (!sequence) {
            return;
        }

        const firstPositions = captureCardPositions();
        setDeletingSequenceId(sequence.__uiId);
        deleteTimerRef.current = window.setTimeout(() => {
            removeSequenceById(sequence.__uiId, firstPositions);
            setDeletingSequenceId(null);
            deleteTimerRef.current = null;
        }, 220);
    }

    const handleSelectAllLights = async (seq_idx, lg_idx) => {
        if (isReadOnlyMode) {
            return;
        }
        const selectAllLights = [...protocolData];
        selectAllLights[seq_idx].light_groups[lg_idx].light = allLights.map(light => light.description).join(' ');
        setProtocolData(selectAllLights);
    }

    const handleRemoveAllLights = async (seq_idx, lg_idx) => {
        if (isReadOnlyMode) {
            return;
        }
        const selectAllLights = [...protocolData];
        selectAllLights[seq_idx].light_groups[lg_idx].light = '';
        setProtocolData(selectAllLights);
        multiselectRefs.current[`${seq_idx}_${lg_idx}`].current.resetSelectedValues();

    }

    const handleAddLightGroup = async (sequence, s_idx) => {
        if (isReadOnlyMode) {
            return;
        }
        // console.log(sequence);
        // console.log(s_idx);
        var addGroup = {
            'light': '',
            'frequency': '',
            'duty_cycle': '50'
        }
        const newLightGroup = [...protocolData];
        newLightGroup[s_idx].light_groups.push(addGroup);
        setProtocolData(newLightGroup);
        // console.log(newLightGroup);
        // console.log(protocolData);
    }

    const handleDeleteLightGroup = (s_idx, lg_idx) => {
        if (isReadOnlyMode) {
            return;
        }
        if (protocolData[s_idx].light_groups.length <= 1) {
            return;
        }

        const newLightGroup = [...protocolData];
        newLightGroup[s_idx].light_groups.splice(lg_idx, 1);
        setProtocolData(newLightGroup);
    }

    const isModalLoading = isLoading || !allSoundFrequencies || !protocolData.length;

        return (
        <div className='modal-table-protocol-data'>
        <div className='modal-protocol-data'>
            <div className='modal-protocol-data-header'>
                <div className='row-pd'>
                    <div className='column-half-pd'>
                        {showProtocolInfo()}
                    </div>
                </div>
                <button className='modal-close-btn-protocol-data' onClick={closeModal} aria-label='Close protocol data modal'>X</button>
            </div>
      <div className='table-wrapper-protocol-data' ref={scrollContainerRef}>

        <div className='sequence-cards' onDragOver={handleSequenceCardsDragOver}>
            {isModalLoading ? (
                <>
                    <section className='sequence-card sequence-card-skeleton'>
                        <div className='sequence-card-layout'>
                            <div className='sequence-badge sequence-badge-span'>
                                <span className='skeleton-block skeleton-pill'></span>
                            </div>
                            <aside className='sequence-left-rail'>
                                <div className='skeleton-block skeleton-line'></div>
                                <div className='skeleton-block skeleton-line'></div>
                            </aside>
                            <div className='sequence-notes-column'>
                                <div className='skeleton-block skeleton-textarea'></div>
                            </div>
                            <div className='sequence-right-content'>
                                <div className='skeleton-block skeleton-card'></div>
                                <div className='skeleton-block skeleton-card'></div>
                            </div>
                        </div>
                    </section>
                    <section className='sequence-card sequence-card-skeleton'>
                        <div className='sequence-card-layout'>
                            <div className='sequence-badge sequence-badge-span'>
                                <span className='skeleton-block skeleton-pill'></span>
                            </div>
                            <aside className='sequence-left-rail'>
                                <div className='skeleton-block skeleton-line'></div>
                                <div className='skeleton-block skeleton-line'></div>
                            </aside>
                            <div className='sequence-notes-column'>
                                <div className='skeleton-block skeleton-textarea'></div>
                            </div>
                            <div className='sequence-right-content'>
                                <div className='skeleton-block skeleton-card'></div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (
            <>
            {protocolData.map((sequence, i) => (
                <React.Fragment key={sequence.__uiId}>
                <section
                    className={`sequence-card${deletingSequenceId === sequence.__uiId ? ' sequence-delete-exit' : ''}${dragSourceIndex !== null && dropInsertIndex === i ? ' sequence-insert-before' : ''}`}
                    ref={(element) => {
                        if (!element) {
                            delete cardRefs.current[sequence.__uiId];
                            return;
                        }
                        cardRefs.current[sequence.__uiId] = element;
                    }}
                    onDragOver={handleDragOverSequence(i)}
                    onDragLeave={handleDragLeaveSequence}
                    onDrop={handleDropSequence}
                >
                    <div className='sequence-card-layout'>
                        <div className='sequence-badge sequence-badge-span'>
                            <span
                                className='sequence-drag-handle'
                                draggable={false}
                                title='Drag to reorder sequence'
                                onPointerDown={handlePointerDragStartSequence(i)}
                                onDragStart={handleDragStartSequence(i)}
                                onDragEnd={handleDragEndSequence}
                            >
                                <BsGripVertical />
                            </span>
                            <span className='sequence-badge-text'>Sequence {sequence.sequence}</span>
                            <span
                                className='sequence-delete-handle'
                                title='Remove this sequence'
                                onClick={!isReadOnlyMode ? handleRemoveSequenceByIndex(i) : undefined}
                            >
                                <BsTrashFill />
                            </span>
                        </div>
                        <div className='sequence-start-minutes'>Starts at {formatMinutes(sequenceStartMinutes[i] || 0)}</div>
                        <aside className='sequence-left-rail'>
                            <label>
                                Length
                                <div className='length-input-row'>
                                    <input
                                        className='center-pd length-input'
                                        type='number'
                                        value={sequence.duration}
                                        readOnly={isReadOnlyMode}
                                        onChange={(val) => {
                                            const newDuration = [...protocolData];
                                            newDuration[i].duration = val.target.value;
                                            setProtocolData(newDuration);
                                        }}
                                    />
                                    <span className='length-unit'>Minutes</span>
                                </div>
                            </label>
                            <label>
                                Audio Hz
                                <select
                                    name='audio_frequencies_description'
                                    value={sequence.audio_frequency}
                                    disabled={isReadOnlyMode}
                                    onChange={(val) => {
                                        const newAudioFrequency = [...protocolData];
                                        newAudioFrequency[i].audio_frequency = val.target.value;
                                        setProtocolData(newAudioFrequency);
                                    }}
                                >
                                    {allAudioFrequencies.map((audio_frequency) => (
                                        <option key={audio_frequency.audio_frequency_id} value={audio_frequency.audio_frequency_id}>
                                            {audio_frequency.description}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </aside>

                        <div className='sequence-notes-column'>
                            <div className='sequence-notes'>
                                <label className='label-left-justified'>Note</label>
                                <textarea
                                    className='small-column-textarea'
                                    value={sequence.note}
                                    readOnly={isReadOnlyMode}
                                    onChange={(val) => {
                                        const newNote = [...protocolData];
                                        newNote[i].note = val.target.value;
                                        setProtocolData(newNote);
                                    }}
                                />
                            </div>
                        </div>

                        <div className='sequence-right-content'>
                    <div className='light-groups-list'>
                        {sequence.light_groups.map((light_group, l) => (
                            <div className='light-group-card' key={i + l}>
                                <div className='light-group-field hz-duty-stack'>
                                    <label>
                                        Pulse
                                        <div className='field-input-row'>
                                            <input
                                                className='center-pd pulse-input'
                                                type='number'
                                                value={light_group.frequency}
                                                readOnly={isReadOnlyMode}
                                                onChange={(freqVal) => {
                                                    const newFrequency = [...protocolData];
                                                    newFrequency[i].light_groups[l].frequency = freqVal.target.value;
                                                    setProtocolData(newFrequency);
                                                }}
                                            />
                                            <span className='field-unit'>HZ</span>
                                        </div>
                                    </label>

                                    <label>
                                        Duty Cycle
                                        <div className='field-input-row'>
                                            <input
                                                className='center-pd duty-input'
                                                type='number'
                                                value={light_group.duty_cycle}
                                                readOnly={isReadOnlyMode}
                                                onChange={(dcVal) => {
                                                    const newDutyCycle = [...protocolData];
                                                    if (dcVal.target.value < 0) {
                                                        dcVal.target.value = 0;
                                                    }
                                                    if (dcVal.target.value > 100) {
                                                        dcVal.target.value = 100;
                                                    }
                                                    newDutyCycle[i].light_groups[l].duty_cycle = dcVal.target.value;
                                                    setProtocolData(newDutyCycle);
                                                }}
                                            />
                                            <span className='field-unit'>%</span>
                                        </div>
                                    </label>
                                </div>

                                <div className='light-group-field lights-field'>
                                    <label className='label-left-justified'>Light Group</label>
                                    <div className='multi-container'>
                                        <Multiselect
                                            displayValue='description'
                                            onKeyPressFn={function noRefCheck(){}}
                                            onRemove={onRemoveHandler(i,l)}
                                            onSearch={function noRefCheck(){}}
                                            onSelect={onSelectHandler(i,l)}
                                            options={allLights}
                                            customCloseIcon='×'
                                            selectedValueDecorator={(value) => (
                                                <span className='chip-label' style={{ color: 'inherit', fontWeight: 500 }}>{value}</span>
                                            )}
                                            style={{
                                                chips: {
                                                    color: '#000000',
                                                    fontWeight: 500,
                                                },
                                            }}
                                            disable={isReadOnlyMode}
                                            ref={multiselectRefs[`${i}_${l}`] || (multiselectRefs.current[`${i}_${l}`] = React.createRef())}
                                            selectedValues={light_group.light.split(' ').map(light => {
                                                if (light !== '') {
                                                    return {
                                                        'description': light,
                                                        'light_value': light,
                                                    };
                                                }
                                                return null;
                                            }).filter(Boolean)}
                                            className='multi-select'
                                        />
                                    </div>
                                    <div className='light-group-icons'>
                                        <BsLightbulbFill onClick={!isReadOnlyMode ? () => handleSelectAllLights(i,l) : undefined} className={`sessions-btn${isReadOnlyMode ? ' disabled-icon' : ''}`}/>
                                        <BsLightbulbOff onClick={!isReadOnlyMode ? () => handleRemoveAllLights(i,l) : undefined} className={`sessions-btn${isReadOnlyMode ? ' disabled-icon' : ''}`}/>
                                        <BsTrashFill onClick={!isReadOnlyMode ? () => handleDeleteLightGroup(i, l) : undefined} className={`light-group-delete-btn${isReadOnlyMode ? ' disabled-icon' : ''}`}/>
                                    </div>
                                </div>

                            </div>
                        ))}
                    </div>

                    <div className='sequence-footer'>
                        <div className='sequence-actions'>
                            {!isReadOnlyMode && (
                                <button
                                    type='button'
                                    className='add-light-group-btn'
                                    onClick={() => handleAddLightGroup(protocolData[i],i)}
                                >
                                    + Add Light Group
                                </button>
                            )}
                        </div>
                    </div>
                        </div>
                    </div>
                </section>
                </React.Fragment>
            ))}
            </>)}

            <div className='sequence-list-actions'>
                {!isReadOnlyMode && (
                    <button
                        type='button'
                        className='add-light-group-btn'
                        onClick={() => handleAddSequence()}
                        disabled={isModalLoading}
                    >
                        + Add Sequence
                    </button>
                )}
            </div>
        </div>

      </div>
                        <form className='modal-protocol-data-actions' onSubmit={handleSubmit}>
                                <button type='button' className='btn-secondary-protocol-data' onClick={closeModal}>Close</button>
                                {!isReadOnlyMode && <button type='submit' className='btn' disabled={isModalLoading}>Save</button>}
                        </form>
    </div>
    </div>
  )

}

export default ModalProtocolDataEdit
